<template>
  <div id="data-list-list-view" class="data-list-container">

    <vx-card v-if="filter" ref="filterCard" :title="$t('Filter')" class="user-list-filters mb-4" actionButtons @refresh="initInput" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
          <p class="mb-2">{{ $t('room') }} <b style="color: #ff6141">*</b></p>
          <v-select
            :options="salles"
            @search="getSalle" 
            :clearable="true" 
            label="libelle"
            v-model="salle_input"
            class="w-full"
          />
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
          <p class="mb-2" > Matière <b style="color: #ff6141">*</b></p>
          <v-select
            :disabled="salle_input ? false : true"
            :options="classeMatieres"
            @search="getClasseMatiere" 
            :clearable="true" 
            :getOptionLabel="getOptionLabel"
            v-model="classeMatiere"
            class="w-full"/>                
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
          <p class="mb-2" >{{ $t("exam_type") }}</p>
          <v-select 
            :reduce="rep => rep.id"
            :options="typeExamens"
            @search="getTypeExamen" 
            :clearable="true" 
            label="libelle"
            v-model="typeExamen"
            class="w-full"/>  
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
          <p class="mb-2" >{{ $t("partition") }}</p>
          <v-select 
            :disabled="true"
            :options="partitions"
            @search="getPartition" 
            :clearable="true" 
            label="long_label"
            v-model="input.partition"
            class="w-full"/>  
        </div>
      </div>
    </vx-card>

    <vs-table :noDataText="$t('No_data_Available')" ref="table" :data="examens">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="false" vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">{{ $t("Actions") }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item @click="addMultiple(0)">
                <span class="flex items-center">
                  <feather-icon icon="FilePlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("multiple_add") }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="objet.popupActive = true">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">{{ $t("add") }}</span>
          </div>

          <vx-tooltip :text="$t('Filterlist')" color="warning">
            <div class="btn-add-new p-4 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-warning border border-solid border-warning" @click="filter=!filter">
              <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            </div>
          </vx-tooltip>
        </div>
          
        <div class="flex flex-wrap">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ param.paginate.page * param.paginate.length - (param.paginate.length - 1) }} - {{ taille - param.paginate.page * param.paginate.length > 0 ? param.paginate.page * param.paginate.length : taille }} {{ $t("of_sur") }} {{ taille }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item :key="indexItem" v-for="(item, indexItem) in itemsPerPages" @click="param.paginate.length=item, getExamens()">
                <span> {{item}} </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-input icon-pack="feather" icon="icon-search" :placeholder="$t('Search')" v-model="search" class="is-label-placeholder mb-8" />
        </div>
      </div>
      
      <template slot="thead">
        <vs-th
          v-if="!salle_input"
        >
          Salle
        </vs-th>
        <vs-th 
          v-if="!classeMatiere"
        >
          Matière
        </vs-th>
        <vs-th 
          v-if="!typeExamen"
        >
          {{ $t("exam_type") }}
        </vs-th>
        <vs-th>
          État
        </vs-th>
        <vs-th>
          {{ $t("valuation_date") }}
        </vs-th>
        <vs-th
          v-if="salle_input"
        >
          Heure de Début
        </vs-th>
        <vs-th
          v-if="salle_input"
        >
          Heure de fin
        </vs-th>
        <vs-th>{{ $t("action") }}</vs-th>
      </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td
                v-if="!salle_input"
              >
                <p class="product-name font-medium truncate">{{ tr.professeurClasseMatiere.salle.libelle }}</p>
              </vs-td>

              <vs-td
                v-if="!classeMatiere"
              >
                <p class="product-name font-medium truncate">{{ tr.professeurClasseMatiere.classeMatiere.matiere.libelle }}</p>
              </vs-td>

              <vs-td
                v-if="!typeExamen"
              >
                <p class="product-name font-medium truncate">{{ tr.typeExamen.libelle }}</p>
              </vs-td>

              <vs-td>
                <vs-chip :color="tr.nonEffectuer ? 'warning' : 'success'">
                  <h4 class="text-white">
                    {{ tr.nonEffectuer ? 'Programmer' : 'Éffectuer' }}
                  </h4>
                </vs-chip>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ $store.state.convertDateTime(new Date(tr.dateEvaluation)).date }}
                </p>
              </vs-td>

              <vs-td
                v-if="salle_input"
              >
                <p class="product-name font-medium truncate">
                  {{ tr.heureDebut }}
                </p>
              </vs-td>

              <vs-td
                v-if="salle_input"
              >
                <p class="product-name font-medium truncate">
                  {{ tr.heureFin }}
                </p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <div class="flex">
                  <vx-tooltip :text="$t('update')" color="warning">
                    <feather-icon
                      style="color: #FF9F43"
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-warning stroke-current"
                      class="mr-2"
                      @click="addMultiple(tr.id)"
                    />
                  </vx-tooltip>
                  <vx-tooltip :text="$t('Delete')" color="danger">
                    <feather-icon
                      @click="examen_delete(tr.id)"
                      style="color: red"
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                </div>
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <div class="items-center">
      <vs-pagination :total="total" v-model="currentPage"></vs-pagination>
    </div>

    <add-examen :objet="objet" />

  </div>
</template>

<script>
let base_self = ''
const input_tempon = {
  id: null, 
  libelle: '',
  partition: '',
  typeExamen: '',
  salle: '',
  classeMatiere: ''
}

import addExamen from './addExamen.vue'

export default {
  components: {
    addExamen
  },
  data () {
    return {
      objet: {
        popupActive: false
      },
      typeExamen: '',
      salle_input: '',
      classeMatiere: '',
      salles: [],
      input1: JSON.parse(JSON.stringify(input_tempon)),
      input: JSON.parse(JSON.stringify(input_tempon)),
      label: ['eleve', 'full_name'],
      paramClasseMatiere: {
        is_get: true,
        paginate: {
          length: 30,
          page: 1
        },
        filter: {
          q_list: [],
          classe__is_active: true,
          classe__niveau__is_active: true,
          classe__niveau__niveauTypePartitions__anneeScolaire__id: this.$store.state.anneeScolaire.id,
          anneeScolaire__id: this.$store.state.anneeScolaire.id
        },
        juste: {
          id: '',
          classe: {
            id: '',
            libelle: '',
            niveau: {
              id: ''
            }
          },
          matiere: {
            libelle: ''
          }
        }
      },
      paramTypeExamen: {
        is_get: true,
        paginate: {
          length: 5,
          page: 1
        },
        filter: {
          q_list: []
        }
      },
      paramPartition: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: [],
          is_active: true
        },
        orderby: ['ordre']
      },
      classeMatieres: [],
      inscriptions: [],
      partitions: [],
      typeExamens: [],
      filter: true,
      search: '',
      param: {},
      itemsPerPages: this.$store.state.itemsPerPages,
      taille: 0,
      currentPage: 1,
      selected: [],
      examens: [],
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  watch: {
    salle_input (value) {
      if (value) {
        base_self.param.filter['professeurClasseMatiere__salle__id'] = value.id
        base_self.paramClasseMatiere.filter['classe__id'] = value.classe.id
        base_self.paramClasseMatiere.filter['anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
        base_self.paramClasseMatiere.filter['classe__niveau__niveauTypePartitions__anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id

        base_self.paramPartition.filter['niveauTypePartition__anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
        base_self.paramPartition.filter['niveauTypePartition__niveau__id'] = value.classe.niveau.id

        base_self.getPartitionSimple()
        base_self.getClasseMatiereSimple()
      } else {
        delete base_self.param.filter['professeurClasseMatiere__salle__id']
        delete base_self.paramClasseMatiere.filter['classe__id']
        delete base_self.paramClasseMatiere.filter['anneeScolaire__id']
        delete base_self.paramClasseMatiere.filter['classe__niveau__niveauTypePartitions__anneeScolaire__id']

        delete base_self.paramPartition.filter['niveauTypePartition__anneeScolaire__id']
        delete base_self.paramPartition.filter['niveauTypePartition__niveau__id']

        base_self.classeMatiere = null
        base_self.input.partition = null
        delete base_self.param.filter['partition__id']
      }

      base_self.getExamens()
    },
    classeMatiere (value) {
      base_self.input.classeMatiere = value
      
      console.log('Je viens d\'entrer loo', value)

      if (value && value.id) {
        base_self.param.filter['professeurClasseMatiere__classeMatiere__id'] = value.id
      } else {
        delete base_self.param.filter['professeurClasseMatiere__classeMatiere__id']
      }

      base_self.getExamens()

      console.log('Je viens d\'entrer loo')
    },
    typeExamen (value) {
      base_self.input.typeExamen = value

      console.log('Je viens d\'entrer loo', value)
      if (value) {
        base_self.param.filter['typeExamen__id'] = value
      } else {
        delete base_self.param.filter['typeExamen__id']
      }

      base_self.getExamens()
    },
    currentPage (value) {
      base_self.param.paginate.page = value
      base_self.getExamens()
    },
    search (value) {
      if (value.length) {
        base_self.param.filter.q_list = [{ 'inscription__eleve__full_name__icontains': value }, { 'partition__long_label__icontains': value }, { 'typeExamen__libelle__icontains': value }, { 'classeMatiere__libelle__icontains': value }]
      } else {
        base_self.param.filter.q_list = []
      }
      base_self.getExamens()
    }
  },
  computed: {
    total () {
      return Math.ceil(base_self.taille / base_self.param.paginate.length)
    }
  },
  methods: {
    getOptionLabel (option) {
      if (typeof option === 'object') {

        return `${option.matiere.libelle}`
      }
      return option
    },
    addMultiple (id = 0) {
      // base_self.$router.push(`/report_cards_management/Exam/${id}`).catch(() => {})
      const routeData = base_self.$router.resolve({path: `/report_cards_management/Exam/${id}`})
      window.open(routeData.href, '_blank')
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    initInput () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.$refs.filterCard.removeRefreshAnimation()
    },
    getTypeExamenSimple () {
      delete base_self.paramTypeExamen.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}TypeExamen`, base_self.paramTypeExamen)
        .then((response) => {
          base_self.typeExamens = JSON.parse(JSON.stringify(response.data.data))

          // console.log('base_self.typeExamens: ', base_self.typeExamens)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getTypeExamen (search, loading) {
      loading(true)
      base_self.paramTypeExamen.filter['libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}TypeExamen`, base_self.paramTypeExamen)
        .then((response) => {
          base_self.typeExamens = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getPartitionSimple () {
      delete base_self.paramPartition.filter['long_label__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Partition`, base_self.paramPartition)
        .then((response) => {
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))

          if (base_self.partitions.length) {
            base_self.input.partition = base_self.partitions[0]
            base_self.param.filter['partition__id'] = base_self.input.partition.id
          }
          // console.log('base_self.partitions: ', base_self.partitions)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getPartition (search, loading) {
      loading(true)
      base_self.paramPartition.filter['long_label__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Partition`, base_self.paramPartition)
        .then((response) => {
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))

          if (base_self.partitions.length) {
            base_self.input.partition = base_self.partitions[0]
          }
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getSalleSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true,
          classe__classeMatieres__isnull: false
        },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: '',
            niveau: {
              id: ''
            }
          }
        },
        orderby: ['classe__ordre', 'ordre'],
        exclude: { code: 'Attente' }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true,
          classe__classeMatieres__isnull: false,
          libelle__icontains: search
        },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: '',
            niveau: {
              id: ''
            }
          }
        },
        orderby: ['classe__ordre', 'ordre'],
        exclude: { code: 'Attente' }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getClasseMatiereSimple () {
      delete base_self.paramClasseMatiere.filter['matiere__libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}ClasseMatiere`, base_self.paramClasseMatiere)
        .then((response) => {
          base_self.classeMatieres = JSON.parse(JSON.stringify(response.data.data))

          console.log('response: ', response)
          console.log('base_self.paramClasseMatiere: ', base_self.paramClasseMatiere)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getClasseMatiere (search, loading) {
      loading(true)
      base_self.paramClasseMatiere.filter['matiere__libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}ClasseMatiere`, base_self.paramClasseMatiere)
        .then((response) => {
          base_self.classeMatieres = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    edit (data) {
      base_self.sidebarData = JSON.parse(JSON.stringify(data))
      /* base_self.sidebarData.classe = base_self.sidebarData.classe.id
      base_self.sidebarData.inscription = base_self.sidebarData.inscription.id
      base_self.sidebarData.partition = base_self.sidebarData.partition.id */
      // base_self.detail__detail = false;
      base_self.toggleDataSidebar(true)
    },
    async examen_delete (id) {
      
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: base_self.$t('Confirmation'),
        text: base_self.$t('Confirm_deletion'),
        acceptText: base_self.$t('Confirm'),
        cancelText: 'Cancel',
        accept: async () => {
          // console.log('id: ', id)
          const params = {
            id
          }
          
          base_self.$http.delete(`${base_self.$store.state.route_for_esm}Examen`, { params })
            .then((response) => {
              window.getESM.success(base_self.$t('The_Exam_is_deleted_successfully'), response)
            })
            .catch(() => {
              window.getESM.error(base_self.$t('Exam_removal_failed'))
            })
        }
      })
    },
    async getExamens () {
      base_self.$vs.loading()

      base_self.$http.post(`${base_self.$store.state.route_for_esm}Examen`, base_self.param)
        .then((response) => {
          base_self.examens = response.data.data
          base_self.taille = response.data.taille

          // console.log('response.data.data: ', response.data.data)

          base_self.$vs.loading.close()
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
          base_self.$vs.loading.close()
        })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    ExamenWebSocket () {
      base_self.$store.state.webSocketFunction(base_self, 'examen')
    }
  },
  created () {
    base_self = this
    base_self.param = JSON.parse(JSON.stringify(base_self.$store.state.paramExamen))

    base_self.ExamenWebSocket()
    base_self.getExamens()

    base_self.getTypeExamenSimple()
    base_self.getSalleSimple()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style>
.vs-input--input {
  border-radius: 20px;
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
}

</style>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
